import React, { useState } from 'react';
import { IconArrowLeft, IconUser, IconCamera, IconCheck } from '@tabler/icons-react';
interface ProfilePageProps {
  onBack: () => void;
}
export function ProfilePage({
  onBack
}: ProfilePageProps) {
  const [name, setName] = useState('Maria Rossi');
  const [email, setEmail] = useState('maria.rossi@email.com');
  const [phone, setPhone] = useState('+39 340 123 4567');
  const [avatar, setAvatar] = useState('https://cdn.magicpatterns.com/uploads/c3jxasi4fCCZ93c9aemubP/adele-shafiee-KCvjle4_4ps-unsplash.jpg');
  const [hasChanges, setHasChanges] = useState(false);
  const handleImageUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setAvatar(reader.result as string);
        setHasChanges(true);
      };
      reader.readAsDataURL(file);
    }
  };
  const handleSave = () => {
    console.log('Save profile:', {
      name,
      email,
      phone,
      avatar
    });
    setHasChanges(false);
    // TODO: Save to backend
  };
  return <div className="flex flex-col h-full" data-id="element-1083">
      {/* Header */}
      <div className="px-4 pt-4 pb-3 border-b border-yeppy-text border-opacity-10" data-id="element-1084">
        <div className="flex items-center gap-3 mb-3" data-id="element-1085">
          <button onClick={onBack} className="flex items-center gap-1 py-2 pr-2 transition-opacity hover:opacity-70" aria-label="Torna a Impostazioni" data-id="element-1086">
            <IconArrowLeft className="w-5 h-5 text-yeppy-text" stroke={2} data-id="element-1087" />
            <span className="font-poppins text-base text-yeppy-text font-medium" data-id="element-1088">
              Impostazioni
            </span>
          </button>
          <div className="flex-1 flex justify-end" data-id="element-1089">
            <h1 className="font-rubik font-bold text-lg text-yeppy-text" data-id="element-1090">
              Profilo
            </h1>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto px-4 py-6" data-id="element-1091">
        <div className="max-w-md mx-auto space-y-6" data-id="element-1092">
          {/* Profile Photo Section */}
          <div className="bg-white border border-yeppy-text border-opacity-10 rounded-2xl p-5" data-id="element-1093">
            <div className="flex items-center gap-3 mb-4" data-id="element-1094">
              <div className="w-10 h-10 rounded-xl bg-yeppy-bg flex items-center justify-center" data-id="element-1095">
                <IconUser className="w-5 h-5 text-yeppy-text" stroke={1.5} data-id="element-1096" />
              </div>
              <h2 className="font-rubik font-semibold text-base text-yeppy-text" data-id="element-1097">
                Foto profilo
              </h2>
            </div>

            <div className="flex flex-col items-center gap-4" data-id="element-1098">
              <div className="relative" data-id="element-1099">
                <div className="w-24 h-24 rounded-full bg-yeppy-bg border-2 border-white shadow-sm flex items-center justify-center overflow-hidden" data-id="element-1100">
                  <IconUser className="w-10 h-10 text-yeppy-text text-opacity-40" stroke={1.5} data-id="element-1101" />
                </div>
                <button className="absolute bottom-0 right-0 w-8 h-8 rounded-full bg-yeppy-text text-white flex items-center justify-center border-2 border-white shadow-sm transition-transform active:scale-95" data-id="element-1102">
                  <IconCamera className="w-4 h-4" stroke={1.5} data-id="element-1103" />
                </button>
              </div>
              <p className="font-poppins text-xs text-yeppy-text text-opacity-60 text-center" data-id="element-1104">
                Clicca per cambiare foto profilo
              </p>
            </div>
          </div>

          {/* Personal Information Section */}
          <div className="bg-white border border-yeppy-text border-opacity-10 rounded-2xl p-5" data-id="element-1105">
            <div className="flex items-center gap-3 mb-4" data-id="element-1106">
              <div className="w-10 h-10 rounded-xl bg-yeppy-bg flex items-center justify-center" data-id="element-1107">
                <IconUser className="w-5 h-5 text-yeppy-text" stroke={1.5} data-id="element-1108" />
              </div>
              <h2 className="font-rubik font-semibold text-base text-yeppy-text" data-id="element-1109">
                Informazioni personali
              </h2>
            </div>

            <div className="space-y-4" data-id="element-1110">
              {/* Name */}
              <div data-id="element-1111">
                <label htmlFor="name" className="block font-poppins text-sm font-medium text-yeppy-text mb-2" data-id="element-1112">
                  Nome completo
                </label>
                <div className="relative" data-id="element-1113">
                  <IconUser className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-yeppy-text text-opacity-40" stroke={1.5} data-id="element-1114" />
                  <input id="name" type="text" value={name} onChange={e => {
                  setName(e.target.value);
                  setHasChanges(true);
                }} className="w-full px-4 py-3 rounded-xl font-poppins text-sm text-yeppy-text bg-white border border-yeppy-text border-opacity-15 focus:outline-none focus:border-yeppy-blue focus:border-opacity-50 transition-colors" data-id="element-1115" />
                </div>
              </div>

              {/* Email */}
              <div data-id="element-1116">
                <label htmlFor="email" className="block font-poppins text-sm font-medium text-yeppy-text mb-2" data-id="element-1117">
                  Email
                </label>
                <input id="email" type="email" value={email} onChange={e => {
                setEmail(e.target.value);
                setHasChanges(true);
              }} className="w-full px-4 py-3 rounded-xl font-poppins text-sm text-yeppy-text bg-white border border-yeppy-text border-opacity-15 focus:outline-none focus:border-yeppy-blue focus:border-opacity-50 transition-colors" data-id="element-1118" />
              </div>

              {/* Phone */}
              <div data-id="element-1119">
                <label htmlFor="phone" className="block font-poppins text-sm font-medium text-yeppy-text mb-2" data-id="element-1120">
                  Telefono
                </label>
                <input id="phone" type="tel" value={phone} onChange={e => {
                setPhone(e.target.value);
                setHasChanges(true);
              }} className="w-full px-4 py-3 rounded-xl font-poppins text-sm text-yeppy-text bg-white border border-yeppy-text border-opacity-15 focus:outline-none focus:border-yeppy-blue focus:border-opacity-50 transition-colors" data-id="element-1121" />
              </div>

              {/* Save Button */}
              {hasChanges && <button onClick={handleSave} className="w-full flex items-center justify-center gap-2 px-4 py-3 rounded-xl font-poppins text-sm font-semibold transition-colors" style={{
              backgroundColor: '#B0EC9C',
              color: '#1D2A36'
            }} data-id="element-1122">
                  <IconCheck className="w-5 h-5" stroke={1.5} data-id="element-1123" />
                  Salva modifiche
                </button>}
            </div>
          </div>
        </div>
      </div>
    </div>;
}